import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const carouselContainer = css`
  text-align: center;
  @media (max-width: ${dimensions.phoneLargeMax}) {
    height: 6rem;
  }
  @media (max-width: ${dimensions.phoneMax}) {
    height: 7rem;
  }
  @media (max-width: ${dimensions.phoneSmallMax}) {
    height: 9rem;
  }
`;
